import cartSlice from "../slices/cartSlice";

export const cartReducers = {
  cart: cartSlice,
};
